<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fill-height>
      <div style="width:100%;height:48px;display:flex;align-items:center;">
        <v-btn v-if="screen=='table'" flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="openDialog">Select Columns</v-btn>
        <v-btn v-if="screen=='table'" flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="downloadCSV">Download</v-btn>
        <v-spacer/>
        <v-radio-group v-model="screen" row style="display:flex;justify-content:flex-end;align-items:center;">
          <v-radio flat value="table" label="Table of measurements" color="rgb(51,82,128)"/>
          <v-radio flat value="graphs" label="Graphs" color="rgb(51,82,128)"/>
        </v-radio-group>
      </div>
      <EngineRawTable class="tabItem" v-if="screen=='table'" v-bind:signalFields="signalFields"/>
      <EngineRawGraphs class="tabItem" v-if="screen=='graphs'" v-bind:parameters1="signalFields.slice(0,12)" v-bind:parameters2="signalFields.slice(12,24)"/>
      <v-dialog v-model="dialog" width="600" height="800">
        <v-card style="width:600px;height:800px;">
          <v-card-title primary class="title" style="height:5%;">Select Column</v-card-title>
          <v-card-text style="height:90%;overflow:auto;">
            <v-layout column fill-height>
              <v-flex d-flex v-for="(s, index) in signalFields" v-bind:key="index">
                <v-layout row>
                  <v-flex v-if="index<12" d-flex xs4 style="align-items:center;">Column {{ index + 1 }} (Upper chart) :</v-flex>
                  <v-flex v-else d-flex xs4 style="align-items:center;">Column {{ index + 1 }} (Lower chart) :</v-flex>
                  <v-flex d-flex xs8>
                    <v-autocomplete v-model="selected[index]" :items="available(selected[index])" :value="s" item-text="title" item-value="param" v-on:change="theListChanged( index, s , selected[index])"/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions style="height:5%;">
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
            <v-btn style="color:white; background-color: rgb(51,82,128);" @click="okDialog">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import EngineRawTable from "./EngineRawTable"
import EngineRawGraphs from "./EngineRawGraphs"

import {globalStore} from "../main.js"

export default {
  name: "EngineRaw",
  components: {
    EngineRawTable,
    EngineRawGraphs
  },
  props: {},
  data() {
    return {
      tabTitles: ['Table of measurements', 'Graphs'],
      screen: 'table',
      dialog: false,
      signalFields: ['STW', 'SOG', 'ME_Power_kW', 'ensp', 'fcon', 'fTemp', 'tscav', 'pscav', 'fRailPres', 'soPresDispl', 'pcomp', 'pmax', 'pmaxPcomp', 'ME_Power_perc', 'tcspeed', 'tTurbIn', 'tTurbO1', 'soi1', 'evcAngleSet1', 'evo1', 'vit_a', 'vit_b', 'vit_c', 'vit_d'],
      selected: ['STW', 'SOG', 'ME_Power_kW', 'ensp', 'fcon', 'fTemp', 'tscav', 'pscav', 'fRailPres', 'soPresDispl', 'pcomp', 'pmax', 'pmaxPcomp', 'ME_Power_perc', 'tcspeed', 'tTurbIn', 'tTurbO1', 'soi1', 'evcAngleSet1', 'evo1', 'vit_a', 'vit_b', 'vit_c', 'vit_d'],
      signalFieldsOverall: [],
      signalFieldsForCancel: []
    }
  },
  created() {
    this.setData();
  },
  mounted() {
  },
  methods: {
    setData() {
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof globalStore.signals.timestamps == 'undefined') {
        return;
      }

      let signalKeys = globalStore.signals.timestamps,
          allSigs = Object.keys(globalStore.signals[signalKeys[0]]),
          mappingKeys = Object.keys(mapping['mapping']);

      for (let i = 0; i < allSigs.length; i++) {
        if (mappingKeys.indexOf(allSigs[i]) > -1) {
          this.signalFieldsOverall.push({
            param: allSigs[i],
            title: ((!!units[allSigs[i]]) ? `${mapping['mapping'][allSigs[i]]} [${units[allSigs[i]]}]` : mapping['mapping'][allSigs[i]])
          });
        } else {
          let param = allSigs[i].replace(/\d+$/, '');

          if (mappingKeys.includes(param)) {
            let column_title = `${mapping['mapping'][param]} ${allSigs[i].substring(param.length)}`
            this.signalFieldsOverall.push({
              param: allSigs[i],
              title: ((!!units[allSigs[i]]) ? `${column_title} [${units[allSigs[i]]}]` : column_title)
            });
          }
        }
      }
    },
    openDialog() {
      this.signalFieldsForCancel = this.signalFields.slice(0);
      this.dialog = true;
    },
    theListChanged(a, b, c) {
      this.$set(this.signalFields, a, c);
    },
    cancelDialog() {
      this.signalFields = this.signalFieldsForCancel.slice(0);

      this.dialog = false;
    },
    okDialog() {
      this.dialog = false;
    },
    downloadCSV() {
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      let csvContent = "data:text/csv;charset=utf-8,",
          columns = [];

      columns.push('Timestamp');

      for (let i = 0; i < this.signalFields.length; i++) {
        if (Object.keys(mapping['mapping']).includes(this.signalFields[i])) {
          let param = this.signalFields[i].replace('1', ''),
              column_title = mapping['mapping'][param]
          columns.push(((!!units[param]) ? `${column_title} [${units[param]}]` : column_title));
        } else {
          let param = this.signalFields[i].substring(0, this.signalFields[i].length - 1),
              column_title = mapping['mapping'][param] + " " + this.signalFields[i].substring(this.signalFields[i].length - 1);

          columns.push(((!!units[param]) ? `${column_title} [${units[param]}]` : column_title));
        }
      }

      csvContent += columns.join(",") + "\r\n";

      let timeStamps = globalStore.signals.timestamps;

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      this.signals = [];

      for (let i = 0; i < timeStamps.length; i++) {
        let item = [];

        let dtString = new Date(timeStamps[i]).toISOString().substring(0, 16).replace('T', ' ');

        item.push(dtString);//timeStamps[i]);

        let useLoad = false,
            mcr = globalStore.loadDiagram['otVal1'];

        if (globalStore.signals[timeStamps[timeStamps.length - 1]]['ME_Power_perc'] == -1000)
          useLoad = true;

        for (let s = 0; s < this.signalFields.length; s++) {
          if (!isNaN(globalStore.signals[timeStamps[i]][this.signalFields[s]])) {
            if (globalStore.signals[timeStamps[i]][this.signalFields[s]] != -1000) {
              if (this.signalFields[s].indexOf('exh_val') > -1 && globalStore.signals[timeStamps[i]][this.signalFields[s]] > 0 && globalStore.signals[timeStamps[i]][this.signalFields[s]] < 1)
                item.push(Number(1).toFixed(2));
              else
                item.push(Number(globalStore.signals[timeStamps[i]][this.signalFields[s]]).toFixed(2));
            } else if ((this.signalFields[s] == 'ME_Power_perc') && (useLoad) && (globalStore.signals[timeStamps[i]]['load'] != -1000))
              item.push(Number(globalStore.signals[timeStamps[i]]['load'] * 100).toFixed(2));
            else if ((this.signalFields[s] == 'ME_Power_kW') && (useLoad) && (globalStore.signals[timeStamps[i]]['load'] != -1000))
              item.push(Number(globalStore.signals[timeStamps[i]]['load'] * mcr).toFixed(2));
            else
              item.push('N/A');
          } else
            item.push('N/A');
        }

        csvContent += item.join(",") + "\r\n";
      }

      var dateString = "";

      if ((globalStore.type == 'today') || (globalStore.type == 'last'))
        dateString = new Date(Math.max(...globalStore.signals.timestamps)).toISOString().slice(0, 16).replace('T', ' ');
      else if (globalStore.dateTo == undefined)
        dateString = new Date(globalStore.signals.timestamps[0]).toISOString().slice(0, 10);
      else
        dateString = new Date(globalStore.signals.timestamps[0]).toISOString().slice(0, 10)
            + '_to_' + new Date(Math.max(...globalStore.signals.timestamps)).toISOString().slice(0, 10);


      var encodedUri = encodeURI(csvContent),
          link = document.createElement("a");

      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "WiDE_" + globalStore.selectedVessel + "_" + dateString + ".csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    available: function (selected) {
      return this.signalFieldsOverall.filter(item => {
        return this.signalFields.indexOf(item.param) < 0 || item.param == selected
      });
    }
  },
  computed: {
    selVessel: function () {
      return globalStore.selectedVessel;
    },
    signals_loaded: function () {
      return globalStore.signals;
    },
    mapping_loaded: function () {
      return globalStore.mapping;
    },
    units_loaded: function () {
      return globalStore.units;
    }
  },
  watch: {
    selVessel:  {
      handler: function () {
        this.setData();
      },
      deep: true,
      immediate: true
    },
    signals_loaded:  {
      handler: function () {
        this.setData();
      },
      deep: true,
      immediate: true
    },
    mapping_loaded:  {
      handler: function () {
        this.setData();
      },
      deep: true,
      immediate: true
    },
    units_loaded:  {
      handler: function () {
        this.setData();
      },
      deep: true,
      immediate: true
    },
  }
}

</script>

<style scoped>

.tabItem {
  height: calc(100vh - 96px);
}

</style>
